import React, { Component } from "react";
import credit from "./../../../assets/images/credit.svg";
import Withdraw from "./../functions/withdraw.js";
import GoBackTokenPage from "./../functions/goback.js";

export default class Credits extends Component {
  render() {
    var creditsbalance = window.creditsbalance;

    var data = this.props.data.cybermiles;

    return (
      <div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="card-box">
              <h4 class="header-title m-t-0 m-b-30">
                Credits {data.balance}
              </h4>

              <div class="widget-box-2">
                <div class="widget-detail-2">
                  <h2 class="m-b-0">
                    <img src={credit} class="token64" alt="credit logo" />{" "}
                    <span id="daobalance">{creditsbalance}</span>{" "}
                  </h2>
                  <p class="text-muted m-b-25">CS</p>
                </div>
                <GoBackTokenPage data={data}/>
              </div>
            </div>
          </div>
        </div>
        <Withdraw name="credits" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/cryptos/credits.js